import React from 'react';

import './style.scss';
import { getNameInitials } from '../../../shared/services/Utility';

const User = ({ name, percentage, isWinner, right }) => {
  return (
    <div className={right ? 'user user-right' : 'user'}>
      <div
        style={{
          background: isWinner
            ? `url(${require('../../../Assets/Images/Icons/green_leaf.png')})`
            : '',
        }}
      >
        <span>{getNameInitials(name).toUpperCase()}</span>
      </div>
      <h6>{name}</h6>
      <p className='percentage'>{`${percentage}%`}</p>
      <div className={isWinner ? 'winner' : ''}>{isWinner ? 'Winner' : ''}</div>
    </div>
  );
};

export default User;
